import HttpFactory from '../factory'
import type { EpisodeOfCare, EpisodeOfCareTeams } from '../types/episodeOfCare'
import type { Report } from '../types/report'

class EpisodeOfCareModule extends HttpFactory<any[]> {
  private PATH = '/episodes-of-care'
  private nextPageUrl = `?pageSize=200`

  async get(id: string): Promise<EpisodeOfCare | EpisodeOfCare[]> {
    if (id) {
      return await this.call<any>('GET', `${this.PATH}/${id}`)
    } else {
      return await this.call<any>('GET', `${this.PATH}`).then((reponse) => reponse.items)
    }
  }

  async postEOC(data: any): Promise<any> {
    return await this.call<any>('POST', `${this.PATH}`, data)
  }

  async getReports(id: string): Promise<Report> {
    return await this.call<any>('GET', `${this.PATH}/${id}/reports/${this.nextPageUrl}`)
  }

  async postReport(data: any, id: string): Promise<Report> {
    return await this.call<any>('POST', `${this.PATH}/${id}/reports`, data)
  }

  async getReport(id: string, reportId: string): Promise<Report> {
    return await this.call<any>('GET', `${this.PATH}/${id}/reports/${reportId}`)
  }

  async getTeams(id: string): Promise<EpisodeOfCareTeams> {
    return await this.call<any>('GET', `${this.PATH}/${id}/teams`)
  }

  async updateTeams(id: string, data: any): Promise<EpisodeOfCareTeams> {
    return await this.call<any>('PUT', `${this.PATH}/${id}/teams`, data)
  }

  async updateEOC(id: string, data: object, revision: string) {
    return await this.call<any>('PATCH', `${this.PATH}/${id}?revision=${revision}`, data)
  }

  async getEOCCreateAccessRule() {
    return await this.call<any>('GET', `/auth/policies/practitioner`)
  }

  async getEOCAccessRuleById(id: string) {
    return await this.call<any>('GET', `/auth/policies/episodes-of-care/${id}`)
  }

  async getEOCAccessRules(id: string) {
    return await this.call<any>('GET', `/auth/policies/episodes-of-care?patientId=${id}`)
  }

  async getByPatientId(id: string, active = true): Promise<EpisodeOfCare[]> {
    return await this.call<any>('GET', this.PATH + '?patientId=' + id + (active ? '&status=active' : '')).then(
      (res) => res.items,
    )
  }
}

export default EpisodeOfCareModule
